/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BaseAttachmentDTO } from '@well/attachment/domain';
import { InvoiceExchangeRateDTO } from '../invoice-exchange-rate-dto.model';
import { JSONable } from '@irian-ro/abstract-resource';
import { InvoiceExternalSpOrderDTO } from './invoice-external-sp-order-dto.model';

export class InvoiceExternalDtoModel extends JSONable {
  clientUuid: string | null = null;
  clientName: string | null = null;
  clientCountry: string | null = null;
  vendorUuid: string | null = null;
  vendorName: string | null = null;
  vendorCountry: string | null = null;
  invoiceSeries: string | null = null;
  issueDate: string | null = null;
  paymentDueDate: string | null = null;
  paymentTimeLimit: number | null = null;
  invoiceStatus?: string | null = null;
  paymentStatus: string | null = null;
  invoiceType: string | null = null;
  currencyCode: string | null = null;
  totalNetAmount: number | null = null;
  totalVATAmount: number | null = null;
  totalAmount: number | null = null;
  canceledInvoiceUuid: string | null = null;
  uuid: string | null = null;
  attachments: BaseAttachmentDTO[] | null = [];
  vatRate: any;
  invoiceExternalSPOrderDTOs: InvoiceExternalSpOrderDTO[] | null = [];
  invoiceExchangeRates: InvoiceExchangeRateDTO[] = [];
  legalEntityUuid: string | null | undefined = undefined;
  customerLegalEntityUuid: string | null | undefined = undefined;
  serviceProviderLegalEntityUuid: string | null | undefined = undefined;
  secondaryCurrencyCode: string | null = null;
  secondaryTotalNetAmount: number | null = null;
  secondaryTotalVATAmount: number | null = null;
  secondaryTotalAmount: number | null = null;
  assignedToInvoice = false;
  assignedToCost = false;
  eFacturaUuid: string | null = null;
  paymentTermsNote: string | null = null;
}
